exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".openchair_openchair__material-icons--whnz9{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.openchair_openchair__openchairRoot--1SkEB{-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;font-family:Lato,sans-serif}", ""]);

// exports
exports.locals = {
	"material-icons": "openchair_openchair__material-icons--whnz9",
	"openchairRoot": "openchair_openchair__openchairRoot--1SkEB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"openchair_[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib!./src/css/openchair.css
// module id = 2
// module chunks = 0